<script setup lang="ts">
import { offerDialog, showOfferUrl } from '@/components/shared/OfferDialog/OfferDialogCompose'
import OfferPage from '@/pages/game/OfferPage.vue'

const { triggerApi } = gamesUtils
const { getApp } = utilsPlugin
const { isDesktop } = tools

const backRoute = ref('')
watch(
  () => offerDialog.value.visible,
  () => {
    if (offerDialog.value.visible) {
      backRoute.value = getApp()?.$route?.fullPath || ''
      if (getApp()?.$route.hash !== '#') {
        backRoute.value += '#'
      }
      showOfferUrl()
    } else {
      const router = utilsPlugin.getApp()?.$router
      if (router) {
        router.replace(backRoute.value)
      }
      backRoute.value = ''
    }
  }
)
function onClose() {
  triggerApi.callTrigger()
}
</script>

<template>
  <el-dialog
    v-model="offerDialog.visible"
    top="0px"
    :modal-class="isDesktop ? 'bg-black/80' : 'bg-white'"
    :class="isDesktop ? 'bg-transparent' : 'bg-white mb-0'"
    width="100%"
    style="--el-dialog-padding-primary: 0"
    destroy-on-close
    :show-close="false"
    @closed="onClose"
  >
    <template #default>
      <div @click="offerDialog.visible = false">
        <div
          class="relative big:rounded-2xl  big:max-w-2xl bg-white text-center mx-auto"
          @click.stop
        >
          <OfferPage
            :key="offerDialog.offer?.id"
            :modal-offer="offerDialog.offer"
          />
          <div class="inline-block absolute top-2 md:top-4  left-0 right-4 text-right">
            <div class="inline-block big:hover:rotate-90 origin-center transition duration-200">
              <icon-ify
                icon="ep:close-bold"
                class="text-xl big:text-2xl stroke-2 inline-block text-white p-0 cursor-pointer"
                @click="offerDialog.visible = false"
              />
            </div>
          </div>
        </div>
      </div>
    </template>
  </el-dialog>
</template>

<style scoped lang="postcss"></style>
